import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../../src/appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from "../../src/core/rest";
import _ from "lodash";

const SLICE_NAME = "liveView";

export const cvxcameracommad = createAsyncThunk(
  "liveView/cvxcameracommad",
  async (data) => {
    try {
     await Rest.post(ApiGatewayUrl + "/videosensors/" + data.video_sensor_id + "/ptz", data);
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
); 

export const liveViewSlice = createSlice({
  name: SLICE_NAME,
  initialState: {
    selections: [],
    copySelections: [],
    layoutId: 0,
    currentNoOfplayers: 9,
    cols: 3,
    currentLayout: 3,
    openPreset: { id: 0, name: '', type: '' },
    changed: false,
    currentPreset: null
  },
  reducers: {
    changedState: (state, action) => {
      state.changed = action.payload;
    },
    setLayouts: (state, action) => {
      return { ...state, layouts: action.payload }
    },
    updateErrorByLayout: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === action.payload.lId && s.deviceId === action.payload.dId);
      if (selection) {
        selection.isError = true;
        selection.isRequesting = false;
        selection.errorMessage = action.payload.errorMessage;
        selection.vProfile = action.payload.lId == 0 && action.payload.vProfile /* 0 means 1x1 layout */
      }
    },
    updateCodecErrorByLayout: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === action.payload.lId);
      if (selection) {
        selection.isError = true;
        selection.isRequesting = false;
        selection.errorMessage = action.payload.errorMessage; 
      }
    },
    updateOpenPresetName: (state, action) => {
      state.openPreset = action.payload;
    },
    updateCurrentPreset: (state, action) => {
      state.currentPreset = action.payload;
      state.openPreset = action.payload;
    },
    clearCurrentPreset: (state) => {
      state.currentPreset = null;
    },
    updateCols: (state, action) => {
      state.cols = action.payload;
      state.currentLayout = action.payload;
      state.currentNoOfplayers = action.payload * action.payload;
    },
    updateCurrentNoOfplayer: (state, action) => {
      state.currentNoOfplayers = action.payload;
    },
    selectLayout: (state, action) => {
      let layoutId = action.payload;
      state.layoutId = layoutId;
    },
    chooseLayout: (state, action) => {
      let cols = action.payload;
      let newNoOfplayers = cols * cols;
      let currNoOfPlayers = state.currentNoOfplayers
      let selections = state.selections;
      state.currentNoOfplayers = newNoOfplayers;
      selections = _.orderBy(selections, 'layoutId');
      if (newNoOfplayers < currNoOfPlayers) {
        selections = selections.slice(0, newNoOfplayers);
      }
      _.map(selections, (s, k) => s.layoutId = k);
      state.selections = selections;
    },
    emptySelections: (state) => {
      return { ...state, selections: [], openPName: null }
    },
    copy: (state, action) => {
      return { ...state, copySelections: action.payload }
    },
    updateSelections: (state, action) => {
      let selections = state.selections;
      selections.push({
        layoutId: action.payload.layoutId,
        deviceId: action.payload.deviceId,
        name: action.payload.name,
        video_codec: action.payload.video_codec,
        agencyName: action.payload.agencyName,
        controllable: action.payload.controllable,
        isRecording: action.payload.isRecording,
        recording: action.payload.recording,
        ptz: action.payload.ptz,
        play_back: action.payload.play_back,
        access_expiry: action.payload.access_expiry,
        ptz_home_enable: action.payload.capabilities != null ? action.payload.capabilities.includes("ptz_home_enable") : false,
        archive_playback_enable: action.payload.capabilities != null ? action.payload.capabilities.includes("archive_playback_enable") : false,
        archive_playback_seekable: action.payload.capabilities != null ? action.payload.capabilities.includes("archive_playback_seekable") : false,
        archive_export_enable: action.payload.capabilities != null ? action.payload.capabilities.includes("archive_export_enable") : false,
        isRequesting: true,
        isError: false
      })

    },
    updateStartRecordingForSelection: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s => s.layoutId === action.payload));
      if (selection) {
        selection.isRecording = true
      }
      state.selections = selections
    },
    updateStopRecordingForSelection: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s => s.layoutId === action.payload));
      if (selection) {
        selection.isRecording = false
      }
      state.selections = selections
      state.copySelections = selections
    },
    cvxLiveVideoResult: (state, action) => {
      let response = action.payload.res;
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === action.payload.lId); //1
      if (selection) {
        selection.stream_url = response.stream_url;
        if(response.codec) selection.video_codec = response.codec;
        selection.deviceId = response.video_sensor_id;
        selection.isRequesting = false;
        selection.isError = false;
        selection.addCameraToGridStatus = false;
        selection.vProfile = action.payload.lId == 0 && action.payload.vProfile /* 1 is high profile and 0 is low profile */
      }
    },
    selectDevice: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === state.layoutId); 
      let ptz_home_enable = action.payload.capabilities != null ? action.payload.capabilities.includes("ptz_home_enable") : false;
      let archive_playback_enable = action.payload.capabilities != null ? action.payload.capabilities.includes("archive_playback_enable") : false;
      let archive_playback_seekable = action.payload.capabilities != null ? action.payload.capabilities.includes("archive_playback_seekable") : false;
      let archive_export_enable = action.payload.capabilities != null ? action.payload.capabilities.includes("archive_export_enable") : false;
       //already have devicename and layoutId pair in the selections 
      if (selection) {
        selection.addCameraToGridStatus = true;
        selection.agencyName = action.payload.agency_name;
        selection.deviceId = action.payload.video_sensor_id;
        selection.name = action.payload.video_sensor_name;
        selection.video_codec = action.payload.video_codec;
        selection.controllable = action.payload.is_controllable;
        selection.ptz = action.payload.ptz;
        selection.isRequesting = true;
        selection.isError = false;
        selection.isRecording = action.payload.isRecording; //recording status
        selection.recording = action.payload.recording;  //recording for acl
        selection.access_expiry = action.payload.access_expiry; //acl access expiry check
        selection.play_back = action.payload.play_back;
        selection.ptz_home_enable = ptz_home_enable;
        selection.archive_playback_enable = archive_playback_enable;
        selection.archive_playback_seekable = archive_playback_seekable;
        selection.archive_export_enable = archive_export_enable;
      } else {
        //add device in selected layoutId and selections
        selections.push({
          layoutId: state.layoutId,
          addCameraToGridStatus: true,
          agencyName: action.payload.agency_name,
          deviceId: action.payload.video_sensor_id,
          name: action.payload.video_sensor_name,
          video_codec: action.payload.video_codec,
          controllable: action.payload.is_controllable,
          ptz: action.payload.ptz,
          isRequesting: true,
          isError: false,
          isRecording: action.payload.isRecording,
          recording: action.payload.recording,
          play_back: action.payload.play_back,
          access_expiry: action.payload.access_expiry,
          ptz_home_enable: ptz_home_enable,
          archive_playback_enable: archive_playback_enable,
          archive_playback_seekable: archive_playback_seekable,
          archive_export_enable: archive_export_enable
        });
      }
    },
    closeDevice: (state, action) => {
      let selections = state.selections;
      let result = selections.filter(s => s.layoutId !== action.payload);
      state.selections = result;
    },
    updateTime: (state, action) => {
      let data = action.payload.data;
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === data.lId); //1
      if (selection) {
        selection.startDateTime = data.startDateTime;
        selection.endDateTime = data.endDateTime;
        selection.startPlayLocalTime = data.startPlayLocalTime;
        selection.startPlayUTCTime = data.startPlayUTCTime;
        selection.currentSeekValue = data.currentSeekValue;
      }
    },
    updatePlayBtnStatus: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === action.payload.layoutId); //1
      if (selection) {
        selection.playBtnStatus = action.payload.status;
      }
    },
    setLoading: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === action.payload);
      if (selection) {
        selection.isRequesting = true;
        selection.isError = false;
      }
    },
    archivedVideoResult: (state, action) => {
      let data = action.payload.data;
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === data.lId); //1
      if (selection) {
        selection.stream_url = data.stream_url;
        if(data.codec) selection.video_codec = data.codec;
        selection.deviceId = data.video_sensor_id;
        selection.stream_id = data.stream_id;
        selection.isArchivedMode = true;
        selection.isRequesting = false;
        selection.isError = false;
        selection.playBtnStatus = 'playing';
      }
    },
    stopArchivedVideoResult: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === action.payload);
      if (selection) {
        selection.stream_id = null;
        selection.stream_url = null;
        selection.isRequesting = false;
        selection.isError = false;
        selection.playBtnStatus = 'stopping';
        selection.currentSeekValue = 0;
        selection.startPlayLocalTime = null;
        selection.startPlayUTCTime = null;
      }
    },
    archivedVideoError: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === action.payload.layoutId);
      if (selection) {
        selection.isError = true;
        selection.errorMessage = action.payload.errMessage;
        selection.stream_id = null;
        selection.stream_url = null;
        selection.isRequesting = false;
      }
    },
    changeLiveMode: (state, action) => {
      let selections = state.selections;
      let selection = _.find(selections, (s) => s.layoutId === action.payload);
      if (selection) {
        selection.isArchivedMode = false;
        selection.currentSeekValue = 0;
        selection.stream_id = null;
        selection.startDateTime = null;
        selection.endDateTime = null;
        selection.startPlayLocalTime = null;
        selection.startPlayUTCTime = null;
        selection.playBtnStatus = 'stopping';
      }
    },
  },
});

export const liveViewActions = liveViewSlice.actions;
export const liveViewState = (state) => state.liveView;
export default liveViewSlice.reducer; 
